import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import Vue from 'vue';
import UploadDocumentRequestModel from '../../generated/types/model/resource/UploadDocumentRequestModel';
import utils from '../utils';
import RequestSummaryResourceViewModel from './RequestSummaryResourceViewModel';

export default class UploadDocumentRequestViewModel extends UploadDocumentRequestModel {
  protected transformToDTO() {
    this.dto.summary = this.summary.getDTO();
  }
  protected transformFromDTO() {}

  get fileDisplay() {
    const translateParams = {
      countOfDocument: this.documentIds?.length,
    };
    let translatedText = '';
    if (this.documentIds?.length === 1) {
      translatedText = Vue.$t('page.memberData.text.uploadedDocument', translateParams);
    } else {
      translatedText = Vue.$t('page.memberData.text.uploadedDocuments', translateParams);
    }
    return translatedText;
  }

  get summary(): RequestSummaryResourceViewModel {
    return new RequestSummaryResourceViewModel().fromDTO({
      sections: [
        {
          title: Vue.$t('page.memberData.title.sendDocument'),
          items: [
            {
              ...utils.insertIf(!!this.subject, {
                label: Vue.$t('page.memberData.label.subject'),
                displayValue: this.subject,
              }),
            },
            {
              ...utils.insertIf(!!this.documentIds, {
                label: Vue.$t('page.memberData.label.pdfUpload'),
                displayValue: this.fileDisplay,
              }),
            },
            {
              ...utils.insertIf(!!this.comment, {
                label: Vue.$t('page.memberData.label.comment'),
                displayValue: this.comment,
              }),
            },
          ],
        },

      ],
    });
  }
}
